var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5463 8.57034C14.1763 7.96547 15.1989 7.96647 15.829 8.57133C16.459 9.1762 16.4601 10.1578 15.83 10.7627C15.1999 11.3676 14.1774 11.3666 13.5473 10.7618C12.9172 10.1569 12.9162 9.17521 13.5463 8.57034Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9815 4.19426C14.5234 3.83837 7.78805 8.67499 7.06357 14.1179C7.04684 14.5934 7.22755 15.043 7.56595 15.3679L8.93317 16.6804C9.27156 17.0052 9.73992 17.1788 10.2352 17.1627C15.9048 16.4667 20.9429 10.0012 20.5722 4.76133C20.5503 4.45177 20.304 4.2153 19.9815 4.19426Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5314 14.0898L16.2167 18.343C16.2167 18.7122 15.9993 19.0498 15.6553 19.215L13.2018 20.3926C12.9385 20.5191 12.631 20.5295 12.3591 20.4213C12.0871 20.3132 11.8774 20.097 11.7843 19.8289L10.6367 17.1373",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3314 8.13672L5.89896 8.40959C5.51432 8.40704 5.16119 8.61335 4.98681 8.94249L3.74318 11.2896C3.60971 11.5415 3.59668 11.8366 3.70747 12.0985C3.81825 12.3603 4.04194 12.5632 4.32058 12.6544L7.11642 13.7746",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47704 18.5835C7.20665 20.311 5.10008 19.9889 3.72656 20.187C3.93291 18.8683 3.60882 16.8571 5.40835 16.5977",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.0e1d30bac18582e97e9f980095ba16e2.svg";
export { ForwardRef as ReactComponent };